import { render, staticRenderFns } from "./ContentDialog.vue?vue&type=template&id=37079fa6"
import script from "./ContentDialog.vue?vue&type=script&lang=js"
export * from "./ContentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports